import { post } from '@/request/rarbActRequest';

export function getQuestionsList(actId, params) {
  return post('/wx/mp/com/act/' + actId + '/getComQuestionsList', params);
}

export function getUserBase(appId, params) {
  return post('/wx/mp/port/' + appId + '/getUserBase', params);
}

export function getJsTicket(appId, params) {
  return post('/wx/mp/port/' + appId + '/getJsTicket', params);
}
